import React from "react";
import { Box, Card, CardContent, LinearProgress, Typography } from '@mui/material';
import { TrendingDown, TrendingFlat, TrendingUp } from '@mui/icons-material';
import { cardColors } from "../helpers/dashboardColors";

const SummaryCard = ({ title, value, secondValue, thirdValue, trendPercentage, progressValue, clickableItem, onClick, icon, cardColor }) => {
    const isPositive = trendPercentage > 0;
    const isZero = trendPercentage == 0;
    return (
        <Card
            sx={{
                width: 170,
                borderRadius: 2,
                boxShadow: 2,
                backgroundColor: cardColors.bgColor,
                ...(onClick && {
                    '&:hover': {
                        cursor: 'pointer',
                        transform: "scale(1.03)",
                    }
                })
            }}
            onClick={onClick}
        >
            <CardContent sx={{ padding: '12px !important' }}>
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <Typography
                            variant="subtitle1"
                            color="textSecondary"
                            sx={{ fontWeight: 500 }}
                        >
                            {title}
                        </Typography>
                        <div style={{ color: cardColors.color }}>
                            {icon}
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                        <div>
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 'bold' }}
                            >
                                {value == null ? '--' : value}
                            </Typography>
                            {secondValue &&
                                <Typography
                                    // variant="caption"
                                    sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}
                                >
                                    {secondValue}
                                </Typography>
                            }
                            {thirdValue &&
                                <Typography
                                    // variant="caption"
                                    sx={{ fontSize: '0.75rem', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}
                                >
                                    {thirdValue}
                                </Typography>
                            }
                        </div>
                        {trendPercentage != null &&
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{
                                    backgroundColor: 'white',
                                    color: isZero ? "#333" : (isPositive ? "#155724" : "#721c24"),
                                    fontSize: '12px', fontWeight: 'bold', display: 'flex', flexDirection: 'row', alignItems: 'center', borderRadius: '4px', padding: '1px 4px'
                                }}>
                                    {isZero ?
                                        <TrendingFlat style={{ fontSize: '12px' }} />
                                        :
                                        <>
                                            {isPositive ?
                                                <TrendingUp style={{ fontSize: '12px' }} />
                                                :
                                                <TrendingDown style={{ fontSize: '12px' }} />
                                            }
                                        </>
                                    }
                                    <span style={{ marginLeft: '2px' }}>{trendPercentage}%</span>
                                </div>
                            </div>
                        }
                    </div>
                    {progressValue != null &&
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <LinearProgress
                                style={{ flex: 1, marginRight: '12px' }}
                                variant="determinate"
                                value={progressValue}
                            />
                            <span style={{ fontSize: '12px' }}>{progressValue}%</span>
                        </div>
                    }

                    {clickableItem &&
                        <Box sx={{
                            marginTop: '4px',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            '&:hover': {
                                transform: "scale(1.08)"
                            }
                        }}
                            onClick={clickableItem.onClick}
                        >
                            <Typography sx={{ fontSize: '0.85rem', color: 'textSecondary', textDecoration: 'underline', }}>
                                {clickableItem.title}:
                            </Typography>
                            <Typography sx={{ marginLeft: '2px', fontSize: '0.9rem', fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.6)' }}>
                                {clickableItem.value}
                            </Typography>
                        </Box>
                    }
                </div>
            </CardContent>
        </Card>
    )
}

export default SummaryCard;